// eslint-disable-next-line no-undef
export const uiConfig = UI_CONFIG;